module.exports = __webpack_public_path__ + "f950766239d4c1005b43ec60a19f212a.svg";